import React, { useState, useEffect, useRef, useMemo } from "react";
import "./ProposalPage.css"; // adjust path to match your project
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import CKYCHome from "../CKYCModule/CKYCHome";
import VeryficationCKYC from "../CKYCModule/VeryficationCKYC";
import DocTypeUpload from "../CKYCModule/DocTypeUpload";
import { baseUrl } from "../index";
import VLoader from "./Loader";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import API from "../utils/API";
import Travellerdetailform from "./TravellerDetailForm";
import Contactdetailform from "./ContactdetailForm";
import MemberDetailForm from "./MemberDetailsForm";
import MemberQuestionsForm from "./MemberQuestionsForm";
import Enquirysummery from "./EnquirySummery";
import { updateTravellerDetails } from "../redux/slices/TravellerDetailsSlice";
import moment from "moment";
import { maskName, maskPan, maskPassport } from "./maskUtils";
// import { CommaSeprator, formatSafeDate } from "../utility/utilityFunctions"; // adjust if path differs

/* ── Stepper config ── */
const STEPS = [
    { key: "1", label: "Proposer Details" },
    { key: "2", label: "Member Details" },
    { key: "3", label: "Additional Details" },
    { key: "4", label: "Communication Address" },
];

const Paymentgateawaye = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const quoteDetails = useSelector((s) => s.QuoteDetails);
    const enquiryState = useSelector((s) => s.Enquiry);
    const travellerDetails = useSelector((s) => s.TravellerDetails);
    const mastersData = useSelector((s) => s.MastersData);
    const editStep = String(location?.state?.editStep || "");
    console.log(enquiryState, mastersData)
    /* ── Normalize incoming quote data ── */
    const normalizeQuoteData = (row) => {
        if (!row) return null;
        const insurerID = row?.insurerID ?? row?.InsurerID ?? row?.InsurerId ?? "";
        const enquiryNo =
            row?.enquiryNo ||
            enquiryState?.EnquiryNo ||
            travellerDetails?.enquiryNo ||
            "";
        const lotNo =
            row?.lotNo || enquiryState?.LotNo || travellerDetails?.lotNo || "";
        const transKey = row?.transKey || row?.TransKey || row?.transkey || "";
        const sumAssured =
            row?.SumAssured ?? row?.sumAssured ?? row?.SumInsured ?? 0;
        const planName = row?.planName || row?.PlanName || "";
        return {
            ...row,
            enquiryNo,
            lotNo,
            transKey,
            insurerID: insurerID ? String(insurerID) : "",
            InsurerID: insurerID ? String(insurerID) : "",
            SumAssured: sumAssured,
            sumAssured,
            planName,
            PlanName: planName,
            productCode: row?.productCode || row?.ProductCode || "",
            coverageTypeId: row?.coverageTypeId || row?.CoverageTypeId || "",
            isVisitingUSACanada: Boolean(
                row?.isVisitingUSACanada ?? row?.IsVisitingUSACanada ?? false,
            ),
        };
    };

    const initialQuote = normalizeQuoteData(
        location?.state?.QuoteData || quoteDetails?.selectedQuotes,
    );
    const locationData = useMemo(
        () =>
            location?.state?.locationData || {
                MobileNo:
                    enquiryState?.EnquiryData?.MobileNo ||
                    travellerDetails?.mobileNo ||
                    "",
                destination:
                    enquiryState?.EnquiryData?.DestinationList ||
                    travellerDetails?.destination ||
                    [],
                startDate:
                    enquiryState?.EnquiryData?.StartDate ||
                    travellerDetails?.startDate ||
                    "",
                endDate:
                    enquiryState?.EnquiryData?.EndDate || travellerDetails?.endDate || "",
                numberofDays:
                    enquiryState?.EnquiryData?.numberofDays ||
                    travellerDetails?.numberOfDays ||
                    0,
                Travellers:
                    enquiryState?.EnquiryData?.Travelers ||
                    travellerDetails?.travellers ||
                    [],
            },
        [
            location?.state?.locationData,
            enquiryState?.EnquiryData?.MobileNo,
            enquiryState?.EnquiryData?.DestinationList,
            enquiryState?.EnquiryData?.StartDate,
            enquiryState?.EnquiryData?.EndDate,
            enquiryState?.EnquiryData?.numberofDays,
            enquiryState?.EnquiryData?.Travelers,
            travellerDetails?.mobileNo,
            travellerDetails?.destination,
            travellerDetails?.startDate,
            travellerDetails?.endDate,
            travellerDetails?.numberOfDays,
            travellerDetails?.travellers,
        ],
    );

    const [quoteData, setQuoteData] = useState(initialQuote);
    const [ProposalData, setProposalData] = useState({});
    const [ShowKyc, setShowKyc] = useState(false);
    const [activeKey, setActiveKey] = useState(editStep || "1");
    const [travellers, setTravellers] = useState([]);
    const [isFormValid, setIsFormValid] = useState(false);
    const [isMemberFormValid, setIsMemberFormValid] = useState(false);
    const [isQuestionFormValid, setIsQuestionFormValid] = useState(false);
    const [memberDetailsData, setMemberDetailsData] = useState([]);
    const [memberQuestionsData, setMemberQuestionsData] = useState({});
    const [isMemberSaving, setIsMemberSaving] = useState(false);
    const memberAutoSubmitTriggeredRef = useRef(false);
    const [address, setAddress] = useState([]);
    const [PincodeState, setPincodeState] = useState({});
    const [preExistingillness, setpreExistingillness] = useState(false);
    const [travellerAddress, settravellerAddress] = useState(null);
    const [kycData, setkycData] = useState([]);
    const [KYCDetails, setKYCDetails] = useState({});
    const [KYCDetailsState, setKYCDetailsState] = useState({});
    const [diseases, setDiseases] = useState([]);
    const [isLoader, setLoader] = useState(false);
    const [isProposerSaving, setIsProposerSaving] = useState(false);
    const [showQuotationBackModal, setShowQuotationBackModal] = useState(false);
    const memberAutoSubmitTimerRef = useRef(null);
    const [ckycModalState, setCkycModalState] = useState({
        open: false,
        mode: "",
        response: null,
        uniqueId: "",
        redirectUrl: "",
    });
    const dispatch = useDispatch();
    const QuoteData = quoteData;
    const incomingProposalData = useMemo(
        () => location?.state?.ProposalData || {},
        [location?.state?.ProposalData],
    );
    const formatINR = (value) =>
        new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 0,
        }).format(Number(value || 0));
    const travellerCount =
        locationData?.Travellers?.length ||
        enquiryState?.EnquiryData?.Travelers?.length ||
        travellerDetails?.travellers?.length ||
        0;
    const skipMemberStep = travellerCount <= 1;
    const visibleSteps = skipMemberStep
        ? [
            { key: "1", sourceKey: "1", label: "Proposer Details" },
            { key: "2", sourceKey: "2", label: "Member Details" },
            { key: "3", sourceKey: "3", label: "Additional Details" },
            { key: "4", sourceKey: "4", label: "Communication Address" },
        ]
        : STEPS.map((step) => ({ ...step, sourceKey: step.key }));

    useEffect(() => {
        const next = normalizeQuoteData(
            location?.state?.QuoteData || quoteDetails?.selectedQuotes,
        );
        // if (!next) {
        //   toast.error("Please select a plan to continue");
        //   navigate("/Quotation");
        //   return;
        // }
        setQuoteData(next);
    }, []);

    useEffect(() => {
        if (editStep) {
            setActiveKey(editStep);
        }
    }, [editStep]);

    useEffect(() => {
        if (!quoteData?.insurerID) return;
        setProposalData((prev) => ({
            ...locationData,
            ...incomingProposalData,
            MobileNo:
                incomingProposalData?.MobileNo ||
                locationData?.MobileNo ||
                prev?.MobileNo ||
                travellerDetails?.mobileNo ||
                "",
        }));
        // CKYC();
    }, [
        quoteData?.insurerID,
        incomingProposalData,
        locationData,
        travellerDetails?.mobileNo,
    ]);

    const convertDateFormat = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };

    const formatDateForApi = (dateString) => {
        if (!dateString) return "";
        if (dateString.includes("-")) return convertDateFormat(dateString);
        return dateString;
    };

    const getRelationNameById = (relationId) => {
        const id = String(relationId || "").trim();
        if (!id) return "";
        const match = getRelationList().find(
            (r) => String(r?.RelationID ?? "").trim() === id,
        );
        return match?.RelationName || "";
    };

    const formatDobForCkyc = (dateString) => {
        const text = String(dateString || "").trim();
        if (!text) return "";

        const ymd = text.match(/^(\d{4})[-/](\d{2})[-/](\d{2})$/);
        if (ymd) return `${ymd[3]}-${ymd[2]}-${ymd[1]}`;

        const dmy = text.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
        if (dmy) return `${dmy[1]}-${dmy[2]}-${dmy[3]}`;

        const parsed = new Date(text);
        if (!Number.isNaN(parsed.getTime())) {
            const day = String(parsed.getDate()).padStart(2, "0");
            const month = String(parsed.getMonth() + 1).padStart(2, "0");
            const year = parsed.getFullYear();
            return `${day}-${month}-${year}`;
        }

        return text;
    };

    const mapGenderCode = (gender) => {
        const next = String(gender || "")
            .trim()
            .toLowerCase();
        if (next === "male" || next === "m") return "Male";
        if (next === "female" || next === "f") return "Female";
        return gender || "";
    };

    const getRelationList = () =>
        Array.isArray(mastersData?.relationList) ? mastersData.relationList : [];
    const getNomineeRelationList = () =>
        Array.isArray(mastersData?.nomineeRelationList)
            ? mastersData.nomineeRelationList
            : [];

    const resolveRelationId = (rawRelation) => {
        const relationList = getRelationList();
        const relationText = String(rawRelation || "").trim();
        if (!relationText) return "";

        const relationLabel = relationText.includes("~")
            ? relationText.split("~").slice(1).join("~").trim()
            : relationText;

        const findMatch = (value) =>
            relationList.find(
                (r) =>
                    String(
                        r?.RelationName ??
                        r?.MasterName ??
                        r?.label ??
                        r?.RelationTypeName ??
                        "",
                    )
                        .trim()
                        .toLowerCase() ===
                    String(value || "")
                        .trim()
                        .toLowerCase(),
            );

        const directMatch = findMatch(relationText);
        const labelMatch = findMatch(relationLabel);
        const codeMatch = relationList.find(
            (r) =>
                String(r?.RelationID ?? r?.Code ?? r?.value ?? "").trim() ===
                relationText ||
                String(r?.RelationID ?? r?.Code ?? r?.value ?? "").trim() ===
                String(relationText.split("~")[0] || "").trim(),
        );

        return (
            directMatch?.RelationID?.toString() ||
            directMatch?.Code?.toString() ||
            labelMatch?.RelationID?.toString() ||
            labelMatch?.Code?.toString() ||
            codeMatch?.RelationID?.toString() ||
            codeMatch?.Code?.toString() ||
            (relationText.includes("~") ? relationText.split("~").shift() : "") ||
            (/^\d+$/.test(relationText) ? relationText : "") ||
            ""
        );
    };
    const resolveNomineeRelationId = (rawRelation) => {
        const relationList = getNomineeRelationList();
        const relationText = String(rawRelation || "").trim();
        if (!relationText) return "";

        const relationLabel = relationText.includes("~")
            ? relationText.split("~").slice(1).join("~").trim()
            : relationText;

        const findMatch = (value) =>
            relationList.find(
                (r) =>
                    String(
                        r?.RelationName ??
                        r?.MasterName ??
                        r?.label ??
                        r?.RelationTypeName ??
                        "",
                    )
                        .trim()
                        .toLowerCase() ===
                    String(value || "")
                        .trim()
                        .toLowerCase(),
            );

        const directMatch = findMatch(relationText);
        const labelMatch = findMatch(relationLabel);
        const codeMatch = relationList.find(
            (r) =>
                String(r?.RelationID ?? r?.Code ?? r?.value ?? "").trim() ===
                relationText ||
                String(r?.RelationID ?? r?.Code ?? r?.value ?? "").trim() ===
                String(relationText.split("~")[0] || "").trim(),
        );

        return (
            directMatch?.RelationID?.toString() ||
            directMatch?.Code?.toString() ||
            labelMatch?.RelationID?.toString() ||
            labelMatch?.Code?.toString() ||
            codeMatch?.RelationID?.toString() ||
            codeMatch?.Code?.toString() ||
            (relationText.includes("~") ? relationText.split("~").shift() : "") ||
            (/^\d+$/.test(relationText) ? relationText : "") ||
            ""
        );
    };
    const getSalutationFromGender = (gender) => {
        const next = String(gender || "")
            .trim()
            .toLowerCase();
        if (next === "male" || next === "m") return "Mr";
        if (next === "female" || next === "f") return "Ms";
        return "";
    };
    const getNomineeRelationName = (rawRelation) =>
        String(rawRelation || "")
            .split("~")
            .slice(1)
            .join("~")
            .trim();
    const getOccupationName = (rawOccupation) => {
        const text = String(rawOccupation || "").trim();
        if (!text) return "";
        if (!text.includes("~")) return text;
        return text.split("~").slice(1).join("~").trim();
    };
    const toUpperDisplay = (value) =>
        String(value || "")
            .trim()
            .toUpperCase();
    const formatDobDisplay = (value) => {
        const text = String(value || "").trim();
        if (!text) return "—";

        const ymd = text.match(/^(\d{4})[-/](\d{2})[-/](\d{2})$/);
        if (ymd) return `${ymd[3]}-${ymd[2]}-${ymd[1]}`;

        const dmy = text.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
        if (dmy) return `${dmy[1]}-${dmy[2]}-${dmy[3]}`;

        return text;
    };
    const getCurrentTraveller = () =>
        travellers?.[0] || locationData?.Travellers?.[0] || {};
    const currentTravellerPreview = getCurrentTraveller();
    const isPreCkycInsurer = () => {
        const insurerId = Number(QuoteData?.insurerID || QuoteData?.InsurerID || 0);
        const insurerList = Array.isArray(mastersData?.insurersList)
            ? mastersData.insurersList
            : [];
        const insurer = insurerList.find(
            (item) =>
                Number(item?.InsurerID || item?.insurerID || item?.InsurerId || 0) ===
                insurerId,
        );

        const match = String(
            insurer?.KYCType ??
            insurer?.KycType ??
            insurer?.kycType ??
            insurer?.CKYCType ??
            insurer?.ckycType ??
            QuoteData?.KycType ??
            QuoteData?.kycType ??
            QuoteData?.CKYCType ??
            QuoteData?.ckycType ??
            "",
        )
            .trim()
            .toLowerCase();
        return match === "pre";
    };

    const buildCheckCkycPayload = (
        proposer,
        contactData = {},
        ckycOptions = {},
    ) => ({
        EnquiryNo: QuoteData?.enquiryNo || enquiryState?.EnquiryNo || "",
        InsurerID: Number(QuoteData?.insurerID || QuoteData?.InsurerID || 0),
        DocType: "PAN",
        DocNumber: String(proposer?.ProposerPAN || "").trim(),
        IsFileUploaded: Boolean(ckycOptions?.isFileUploaded),
        DOB: formatDobForCkyc(proposer?.dob || ""),
        Name: String(proposer?.fullName || "").trim(),
        Gender: mapGenderCode(proposer?.gender) === "Female" ? "F" : "M",
        //MobileNo: String(
        //    contactData?.MobileNo || ProposalData?.MobileNo || "",
        //).trim(),
        MobileNo: String(contactData?.MobileNo || getProposerMobile()).trim(),
        EmailID: String(contactData?.Email || proposer?.email || "").trim(),
        ProductType: 5,
        FromHealth: false,
        IsCorporate: false,
        IsRedirectUrl: Boolean(ckycOptions?.isRedirectUrl),
        UniqueID: String(
            ckycOptions?.uniqueId ||
            QuoteData?.enquiryNo ||
            enquiryState?.EnquiryNo ||
            "",
        ).replace(/[^A-Za-z0-9]/g, ""),
        SelectedPOA: ckycOptions?.SelectedPOA || "",
        SelectedPOI: ckycOptions?.SelectedPOI || "",
        SelectedPOAValue: ckycOptions?.SelectedPOAValue || "",
        SelectedPOIValue: ckycOptions?.SelectedPOIValue || "",
        nomineeDetails: {
            name: String(proposer?.nomineeName || "").trim(),
            RelationShip: getNomineeRelationName(proposer?.trv_nomineerelation),
        },
        AddressDetails: {
            CAddressLine1: "",
            CAddressLine2: "",
            CCity: "",
            CDistrict: "",
            CPinCode: null,
            CState: "",
            PAddressLine1: "",
            PAddressLine2: "",
            PCity: "",
            PDistrict: "",
            PPinCode: null,
            PState: "",
        },
    });
    const verifyCkycStatus = async (
        proposer,
        contactData = {},
        ckycOptions = {},
    ) => {
        try {
            const payload = buildCheckCkycPayload(proposer, contactData, ckycOptions);
            const res = await API.CallRequestWithHeader({
                URL: "CheckCkycStatus",
                PostString: JSON.stringify(payload),
            });

            return res;
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    const saveProposalProposerRequest = async (contactData = {}) => {
        const proposer = travellers?.[0] || locationData?.Travellers?.[0] || {};
        const nomineeRelationText = String(
            proposer.trv_nomineerelation || proposer.Relation || "",
        )
            .split("~")
            .pop()
            .trim()
            .toLowerCase();
        const maritalStatus = nomineeRelationText.includes("spouse")
            ? "Married"
            : "Single";
        const proposalMeta = {
            enquiryNo: QuoteData?.enquiryNo || enquiryState?.EnquiryNo || "",
            insurerId: QuoteData?.insurerID || QuoteData?.InsurerID || "",
            planId:
                QuoteData?.PlanId || QuoteData?.planId || QuoteData?.PlansID || "",
            quoteTransKey: QuoteData?.transKey || QuoteData?.TransKey || "",
            lotNo: QuoteData?.lotNo || enquiryState?.LotNo || "",
        };

        const trimmedProposer = {
            fullName: String(proposer.fullName || "").trim(),
            dob: proposer.dob || "",
            salutation: String(proposer.salutation || "").trim(),
            gender: proposer.gender || "",
            pan: String(proposer.ProposerPAN || "").trim(),
            email: String(contactData?.Email || proposer.email || "").trim(),
           /* phone: String(
                contactData?.MobileNo || ProposalData?.MobileNo || "",
            ).trim(),*/

            phone: String(contactData?.MobileNo || getProposerMobile()).trim(),
            educationId: String(proposer.education || "").trim(),
            occupationId: String(proposer.occupation || "").split("~")[0] || "0",
            maritalStatus,
            annualIncome: String(proposer.annualincome || "0").trim(),
            passport: String(proposer.passportNumber || "").trim(),
            visaType: proposer.visaType || "Tourist",
        };


        const trimmedNominee = {
            fullName: String(proposer.nomineeName || "").trim(),
            relation: {
                RelationID: resolveNomineeRelationId(proposer.trv_nomineerelation),
            },

        };

        console.log(proposer, "hhhhhhhhh")



        dispatch(
            updateTravellerDetails({
                //mobileNo: ProposalData?.MobileNo || "",
                mobileNo: getProposerMobile(),
                startDate: locationData?.startDate || "",
                endDate: locationData?.endDate || "",
                numberofDays: locationData?.numberofDays || 0,
                destination: locationData?.destination || [],
                enquiryNo: proposalMeta.enquiryNo,
                policyType: QuoteData?.PolicyType || "",
                tripType:
                    QuoteData?.tripType || enquiryState?.EnquiryData?.TripType || "",
                tripDuration: String(locationData?.numberofDays || ""),
                sumAssured: Number(QuoteData?.SumAssured || 0),
                lotNo: proposalMeta.lotNo,
                insurerID: proposalMeta.insurerId,
                travellers: [
                    {
                        ...proposer,
                        fullName: trimmedProposer.fullName,
                        email: trimmedProposer.email,
                        ProposerPAN: trimmedProposer.pan,
                        passportNumber: trimmedProposer.passport,
                        occupation: proposer.occupation || "",
                        education: proposer.education || "",
                        annualincome: trimmedProposer.annualIncome,
                        visaType: trimmedProposer.visaType,
                        nomineeName: trimmedNominee.fullName,
                        trv_nomineerelation: proposer.trv_nomineerelation || "",
                        relation: proposer.trv_nomineerelation || "",
                    },
                ],
            }),
        );

        const payload = {
            EnquiryNo: proposalMeta.enquiryNo,
            InsurerId: proposalMeta.insurerId,
            PlanId: String(proposalMeta.planId),
            QuoteTransKey: proposalMeta.quoteTransKey,
            LotNo: proposalMeta.lotNo,
            ProposerDetail: {
                Salutation: trimmedProposer.salutation || "",
                FullName: trimmedProposer.fullName,
                DoB: formatDateForApi(trimmedProposer.dob),
                Gender: mapGenderCode(trimmedProposer.gender),
                AadharNo: "",
                PanNo: trimmedProposer.pan || "",
                Email: trimmedProposer.email || "",
                MobileNo: trimmedProposer.phone || "",
                EducationId: Number(trimmedProposer.educationId || 0),
                OccupationId: Number(trimmedProposer.occupationId || 0),
                OccupationName: getName(proposer?.occupation),

                MaritalStatus: trimmedProposer.maritalStatus || "",
                AnnualIncome: Number(trimmedProposer.annualIncome || 0),
                PassportNo: trimmedProposer.passport || "",
                NameOfNominee: trimmedNominee.fullName,

                RelationWithNomineeId:
                    trimmedNominee.relation?.RelationID?.toString() || "",
                RelationWithNomineeName:
                    getName(proposer.trv_nomineerelation) || "",


                VisaType: trimmedProposer.visaType || "Tourist",
            },
        };

        const res = await API.CallRequestWithHeader({
            URL: "SaveProposalProposerRequest",
            PostString: JSON.stringify(payload),
        });

        if (res?.StatusCode === 200 || res?.statusCode === 200) {
            return { ok: true, response: res?.Response || res?.response || res };
        }

        return {
            ok: false,
            message: res?.Message || res?.message || "Failed to save proposal",
        };
    };

    const closeCkycModal = () => {
        setCkycModalState({
            open: false,
            mode: "",
            response: null,
            uniqueId: "",
            redirectUrl: "",
        });
    };

    const openCkycModalFromResponse = (res, options = {}) => {
        const response = res?.Response || res?.response || {};
        const statusCode = res?.StatusCode ?? res?.statusCode;

        if (statusCode === 200 && response?.CKYCStatus) {
            closeCkycModal();
            setActiveKey("2");
            return true;
        }

        if (statusCode === 480) {
            if (options?.fromRedirectSubmit) {
                toast.error(
                    response?.ErrMsg || response?.Message || "CKYC verification failed",
                );
                closeCkycModal();
                return false;
            }

            const uploadFileType = String(
                response?.UploadFileType || "",
            ).toLowerCase();
            const needsUpload =
                response?.IsUploadFile ||
                uploadFileType.includes("poi") ||
                uploadFileType.includes("poa");
            const redirectUrl =
                response?.RedirectLink ||
                response?.Redirecturl ||
                response?.RedirectURL ||
                "";

            setCkycModalState({
                open: true,
                mode: needsUpload ? "upload" : "redirect",
                response,
                uniqueId: String(response?.CKYCRefID || response?.UniqueID || ""),
                redirectUrl,
            });
            return false;
        }
        // setActiveKey("2");
        toast.error(response?.ErrMsg || response?.Message || "KYC pending");
        return false;
    };

    const handleProposerContinue = async () => {
        if (isProposerSaving || !isFormValid) return;
        setIsProposerSaving(true);
        try {
            const saveResult = await saveProposalProposerRequest();
            if (!saveResult.ok) {
                toast.error(saveResult.message || "Failed to save proposal");
                return;
            }
            if (QuoteData?.insurerID == 102) {
                setActiveKey("2");
                return;
            }
            if (isPreCkycInsurer() && QuoteData?.insurerID != 102) {
                const proposer = travellers?.[0] || locationData?.Travellers?.[0] || {};
                const ckycRes = await verifyCkycStatus(proposer, {
                    Email: proposer?.email || "",
                    //MobileNo: ProposalData?.MobileNo || "",
                    MobileNo: getProposerMobile(),
                });
                if (!ckycRes) {
                    toast.error("KYC pending");
                    return;
                }
                if (!openCkycModalFromResponse(ckycRes)) {
                    return;
                }
            } else {
                toast.error("KYC pending");
                return;
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to save proposal");
        } finally {
            setIsProposerSaving(false);
        }
    };
    const getName = (value) => {
        if (!value) return "";

        return value.includes("~")
            ? value.split("~").slice(1).join("~").trim()
            : value.trim();
    };
    const getMemberTravellerSource = () =>
        (Array.isArray(travellers) && travellers.length > 0
            ? travellers
            : locationData?.Travellers || []
        ).slice(1);

    const buildSaveProposerMemberDetailsPayload = (
        currentTraveller = {},
        memberRows = [],
    ) => {
        console.log(currentTraveller)
        const relationId = resolveRelationId(
            currentTraveller?.relation ||
            currentTraveller?.relationId ||
            currentTraveller?.RelationWithProposerId ||
            1,
        );
        const memberTravellerSource = getMemberTravellerSource();
        const listOfMembers = [
            {
                MemberKey: "traveller_primary",
                FullName: String(currentTraveller?.fullName || "").trim(),
                DoB: moment(currentTraveller?.dob || "", "YYYY-MM-DD").format(
                    "DD-MM-YYYY",
                ),
                Gender: mapGenderCode(currentTraveller?.gender),
                FatherName: String(
                    currentTraveller?.fatherName || currentTraveller?.FatherName || "",
                ).trim(),
                AadharNo: String(
                    currentTraveller?.aadharNo || currentTraveller?.AadharNo || "",
                ).trim(),
                PanNo: String(currentTraveller?.ProposerPAN || "").trim(),
                Email: String(currentTraveller?.email || "").trim(),
                //MobileNo: String(
                //    ProposalData?.MobileNo || travellerDetails?.mobileNo || "",
                //).trim(),
                MobileNo: getProposerMobile(),
                EducationId: Number(
                    currentTraveller?.education || currentTraveller?.EducationId || 0,
                ),
                OccupationId: Number(
                    String(currentTraveller?.occupation || "")
                        .split("~")
                        .shift() ||
                    currentTraveller?.OccupationId ||
                    0,
                ),
                OccupationName: getName(
                    currentTraveller?.occupation || "")
                ,
                MaritalStatus: String(
                    currentTraveller?.maritalstatus ||
                    currentTraveller?.maritalStatus ||
                    "",
                ).trim(),
                AnnualIncome: Number(
                    currentTraveller?.annualincome || currentTraveller?.annualIncome || 0,
                ),
                Salutation:
                    String(currentTraveller?.salutation || "").trim() ||
                    getSalutationFromGender(currentTraveller?.gender),
                PassportNo: String(currentTraveller?.passportNumber || "").trim(),


                NameOfNominee: String(currentTraveller?.nomineeName || "").trim(),
                RelationWithNomineeId: resolveNomineeRelationId(
                    currentTraveller?.trv_nomineerelation,
                ),
                RelationWithNomineeName: getName(
                    currentTraveller?.trv_nomineerelation,
                ),
                VisaType: String(currentTraveller?.visaType || "").trim(),
                //RelationWithProposerId: String(relationId || "1").trim(),
                RelationWithProposerId: String(relationId || "").trim(),
                RelationWithProposerName: getRelationNameById(relationId) || "Self",
                IsPrimary: true,
                IsUnderMedication: false,
            },
            ...memberRows.map((memberRow = {}, index) => {
                const baseTraveller = memberTravellerSource[index] || {};
                const memberRelationId = resolveRelationId(
                    baseTraveller?.relation ||
                    baseTraveller?.relationId ||
                    baseTraveller?.RelationWithProposerId ||
                    memberRow?.relation ||
                    index + 2,
                );
                return {
                    MemberKey: `traveller_${index + 2}`,
                    FullName: String(
                        memberRow?.fullName || baseTraveller?.fullName || "",
                    ).trim(),
                    DoB: formatDateForApi(memberRow?.dob || baseTraveller?.dob || ""),
                    Gender: mapGenderCode(memberRow?.gender || baseTraveller?.gender),
                    FatherName: String(
                        baseTraveller?.fatherName || baseTraveller?.FatherName || "",
                    ).trim(),
                    AadharNo: String(
                        baseTraveller?.aadharNo || baseTraveller?.AadharNo || "",
                    ).trim(),
                    PanNo: String(baseTraveller?.ProposerPAN || "").trim(),
                    Email: String(baseTraveller?.email || memberRow?.email || "").trim(),
                    MobileNo: String(
                        ProposalData?.MobileNo || travellerDetails?.mobileNo || "",
                    ).trim(),
                    EducationId: Number(
                        baseTraveller?.education || baseTraveller?.EducationId || 0,
                    ),
                    OccupationId: "0",
                    MaritalStatus: String(
                        baseTraveller?.maritalstatus || baseTraveller?.maritalStatus || "",
                    ).trim(),
                    AnnualIncome: Number(
                        baseTraveller?.annualincome || baseTraveller?.annualIncome || 0,
                    ),
                    Salutation:
                        String(memberRow?.salutation || "").trim() ||
                        getSalutationFromGender(memberRow?.gender || baseTraveller?.gender),
                    PassportNo: String(
                        memberRow?.passportNumber || baseTraveller?.passportNumber || "",
                    ).trim(),


                    NameOfNominee: String(memberRow?.nomineeName || "").trim(),
                    RelationWithNomineeId: resolveNomineeRelationId(
                        memberRow?.nomineeRelation,
                    ),
                    VisaType: String(
                        memberRow?.visaType || baseTraveller?.visaType || "",
                    ).trim(),



                    //RelationWithProposerId: String(memberRelationId || index + 2).trim(),
                    RelationWithProposerId: String(memberRelationId || "").trim(),
                    RelationWithProposerName: getRelationNameById(memberRelationId),
                    OccupationId: "0",
                    IsPrimary: false,
                    IsUnderMedication: false,
                };
            }),
        ];
        return {
            EnquiryNo: QuoteData?.enquiryNo || enquiryState?.EnquiryNo || "",
            InsurerID: String(QuoteData?.insurerID || QuoteData?.InsurerID || ""),
            PlanId: Number(
                QuoteData?.PlanId || QuoteData?.planId || QuoteData?.PlansID || 0,
            ),
            QuoteTransKey: QuoteData?.transKey || QuoteData?.TransKey || "",
            LotNo: QuoteData?.lotNo || QuoteData?.LotNo || "",
            ListOfMembers: listOfMembers,
        };
    };

    const saveProposerMemberDetailsRequest = async (memberRows = []) => {
        const currentTraveller = getCurrentTraveller();
        const payload = buildSaveProposerMemberDetailsPayload(
            currentTraveller,
            memberRows,
        );
        const res = await API.CallRequestWithHeader({
            URL: "SaveProposerMemberDetails",
            PostString: JSON.stringify(payload),
        });

        const apiOk =
            res?.status === true ||
            res?.response === true ||
            res?.StatusCode === 200 ||
            res?.statusCode === 200;

        if (!apiOk) {
            throw new Error(
                res?.message || res?.Message || "Unable to save member details",
            );
        }

        return res;
    };

    const handleRedirectKycSubmit = async () => {
        const proposer = travellers?.[0] || locationData?.Travellers?.[0] || {};
        const ckycRes = await verifyCkycStatus(
            proposer,
            {
                Email: proposer?.email || "",
                MobileNo: ProposalData?.MobileNo || "",
            },
            {
                isRedirectUrl: true,
                uniqueId: ckycModalState?.uniqueId || "",
            },
        );

        if (!ckycRes) {
            toast.error("KYC pending");
            return;
        }

        if (!openCkycModalFromResponse(ckycRes, { fromRedirectSubmit: true })) {
            return;
        }
    };

    const handleUploadSuccess = async (uploadDetails = {}) => {
        const proposer = travellers?.[0] || locationData?.Travellers?.[0] || {};
        const ckycRes = await verifyCkycStatus(
            proposer,
            {
                Email: proposer?.email || "",
                MobileNo: ProposalData?.MobileNo || "",
            },
            {
                isFileUploaded: true,
                SelectedPOA: uploadDetails?.SelectedPOA || "",
                SelectedPOI: uploadDetails?.SelectedPOI || "",
                SelectedPOAValue: uploadDetails?.selectedPOAValue || "",
                SelectedPOIValue: uploadDetails?.SelectedPOIValue || "",
            },
        );

        if (!ckycRes) {
            toast.error("KYC pending");
            return;
        }

        if (!openCkycModalFromResponse(ckycRes)) {
            return;
        }
    };

    const handleQuotationBackClick = () => {
        setShowQuotationBackModal(true);
    };

    const handleQuotationBackConfirm = () => {
        setShowQuotationBackModal(false);
        navigate("/Quotation", { replace: true });
    };

    const handleQuotationBackCancel = () => {
        setShowQuotationBackModal(false);
    };

    const handleMemberContinue = async (isAutoSubmit = false) => {
        if (skipMemberStep) {
            if (isMemberSaving) return;
            setIsMemberSaving(true);
            try {
                await saveProposerMemberDetailsRequest();
                setActiveKey("3");
            } catch (error) {
                console.error(error);
                toast.error(error?.message || "Failed to save member details");
            } finally {
                setIsMemberSaving(false);
            }
            return;
        }
        if (!isMemberFormValid) return;
        if (isMemberSaving) return;
        setIsMemberSaving(true);
        try {
            await saveProposerMemberDetailsRequest(memberDetailsData);
            setActiveKey("3");
        } catch (error) {
            console.error(error);
            toast.error(error?.message || "Failed to save member details");
        } finally {
            setIsMemberSaving(false);
        }
    };

    useEffect(() => {
        if (
            !skipMemberStep ||
            activeKey !== "2" ||
            memberAutoSubmitTriggeredRef.current
        )
            return;
        memberAutoSubmitTimerRef.current = setTimeout(() => {
            memberAutoSubmitTriggeredRef.current = true;
            handleMemberContinue(true);
        }, 3500);
        return () => {
            if (memberAutoSubmitTimerRef.current) {
                clearTimeout(memberAutoSubmitTimerRef.current);
                memberAutoSubmitTimerRef.current = null;
            }
        };
    }, [activeKey, skipMemberStep]);

    const [isAdditionalSaving, setIsAdditionalSaving] = useState(false);

    const buildAdditionalDetailsPayload = () => {
        const doctorDetails = travellerDetails?.doctorDetails || {};
        const companyDetails = travellerDetails?.companyDetails || {};

        const isDoctorEnabled = Boolean(doctorDetails?.enabled);
        const isCompanyEnabled = Boolean(companyDetails?.enabled);

        return {
            EnquiryNo: QuoteData?.enquiryNo || enquiryState?.EnquiryNo || "",
            PolicyType:
                QuoteData?.PolicyType ||
                enquiryState?.EnquiryData?.PolicyType ||
                "Individual",
            TripType:
                QuoteData?.tripType || enquiryState?.EnquiryData?.TripType || "Single",
            QuoteTransKey: QuoteData?.transKey || QuoteData?.TransKey || "",
            LotNo: QuoteData?.lotNo || enquiryState?.LotNo || "",
            InsurerID: Number(QuoteData?.insurerID || QuoteData?.InsurerID || 0),
            PlanId: Number(
                QuoteData?.PlanId || QuoteData?.planId || QuoteData?.PlansID || 0,
            ),
            IsDoctorDetails: isDoctorEnabled,
            DoctorDetails: {
                Name: isDoctorEnabled
                    ? String(doctorDetails?.doctorName || "").trim()
                    : "",
                Address1: isDoctorEnabled
                    ? String(doctorDetails?.addressLine1 || "").trim()
                    : "",
                Address2: isDoctorEnabled
                    ? String(doctorDetails?.addressLine2 || "").trim()
                    : "",
                CityID: 0,
                DistrictID: 0,
                StateID: 0,
                Pincode: isDoctorEnabled ? Number(doctorDetails?.pincode || 0) : 0,
                MobileNo: isDoctorEnabled ? Number(doctorDetails?.mobileNo || 0) : 0,
            },
            UniversityDetails: {
                UniversityName: "",
                UniversityCountryId: 0,
                UniversityStateName: "",
                CityName: "",
                PhoneNumber: "",
                MobileNumber: 0,
                EmailId: "",
                Fax: "",
            },
            CourseDetails: {
                CourseDuration: 3,
                NoOfSems: 1,
                TutionFeePerSem: 0,
            },
            SponsorName: "",
            SponsorAddress: {
                Address1: "",
                CityName: "",
                Pincode: "",
                MobileNo: 0,
                StateName: "",
                Email: "",
            },
            IsCompanyDetails: isCompanyEnabled,
            CompanyName: isCompanyEnabled
                ? String(companyDetails?.companyName || "").trim()
                : "",
            Address: {
                Address1: isCompanyEnabled
                    ? String(companyDetails?.addressLine1 || "").trim()
                    : "",
                Address2: isCompanyEnabled
                    ? String(companyDetails?.addressLine2 || "").trim()
                    : "",
                Address3: "",
                CityID: 0,
                DistrictID: 0,
                StateID: 0,
                MobileNo: isCompanyEnabled ? Number(companyDetails?.mobileNo || 0) : 0,
                Country: "",
                Pincode: isCompanyEnabled ? Number(companyDetails?.pincode || 0) : 0,
                Email: "",
                Fax: "",
            },
        };
    };

    const handleQuestionsContinue = async () => {
        if (!isQuestionFormValid || isAdditionalSaving) return;

        // Flush latest answers to Redux first so buildAdditionalDetailsPayload
        // can read them from travellerDetails in the same render cycle.
        // We also keep them in local state via memberQuestionsData.
        dispatch(
            updateTravellerDetails({
                ...travellerDetails,
                memberQuestions:
                    memberQuestionsData || travellerDetails?.memberQuestions || {},
                questions: memberQuestionsData || travellerDetails?.questions || {},
                medicalQuestions:
                    memberQuestionsData || travellerDetails?.medicalQuestions || {},
                doctorDetails: travellerDetails?.doctorDetails || {},
                companyDetails: travellerDetails?.companyDetails || {},
            }),
        );

        setIsAdditionalSaving(true);
        try {
            const payload = buildAdditionalDetailsPayload();
            const res = await API.CallRequestWithHeader({
                URL: "SaveAdditionalDetails",
                PostString: JSON.stringify(payload),
            });

            const apiOk =
                res?.StatusCode === 200 ||
                res?.statusCode === 200 ||
                res?.status === true ||
                res?.response === true;

            if (!apiOk) {
                toast.error(
                    res?.Message || res?.message || "Failed to save additional details",
                );
                return;
            }

            setActiveKey("4");
        } catch (error) {
            console.error(error);
            toast.error("Failed to save additional details");
        } finally {
            setIsAdditionalSaving(false);
        }
    };
    const canNavigateToStep = (sourceKey) => {
        const current = Number(activeKey);
        const target = Number(sourceKey);
        if (Number.isNaN(current) || Number.isNaN(target)) return false;
        return target <= current;
    };

    // const CKYC = async () => {
    //   try {
    //     const body = { CompanyID: quoteData.insurerID, MasterType: "CKYCINPUT" };
    //     const res = await axios.post(`${baseUrl}/services/call`, {
    //       URL: "/Master/GetInputKyc",
    //       PostString: JSON.stringify(body),
    //     });
    //     if (res.status === 200) setkycData(res.data.response);
    //   } catch (e) {
    //     return Promise.resolve([]);
    //   }
    // };

    const paymentsummery = async () => {
        try {
            setLoader(true);
            const traveller = travellers[0] || locationData?.Travellers?.[0] || {};
            const body = {
                Salutation: traveller.salutation,
                FullName: traveller.fullName,
                Gender: traveller.gender,
                PassportNumber: traveller.passportNumber,
                Occupation: traveller.occupation,
                Dob: convertDateFormat(traveller.dob),
                VisaType: traveller.visaType,
                enquiryno: QuoteData?.enquiryNo,
                InsurerID: QuoteData?.insurerID,
                SumAssured: QuoteData?.SumAssured,
                TransKey: QuoteData?.transKey,
                LotNo: QuoteData?.lotNo,
                MemberDetails: travellers.map((row) => {
                    const cityState = travellerAddress?.stateCity || {};
                    const cityIdParts = String(cityState?.cityId || "").split("~");
                    const districtId = cityIdParts[0] || "";
                    const cityId = cityIdParts[1] || "";
                    return {
                        Salutation: row.salutation,
                        Gender: row.gender,
                        FullName: row.fullName,
                        PassportNumber: row.passportNumber,
                        enquiryno: QuoteData?.enquiryNo,
                        Dob: convertDateFormat(row.dob),
                        Occupation: row.occupation,
                        Address1: travellerAddress?.Address1,
                        Address2: travellerAddress?.Address2,
                        Pincode: travellerAddress?.Pincode,
                        MobileNo: travellerAddress?.MobileNo,
                        Email: travellerAddress?.Email,
                        NomineeName: row.nomineeName,
                        VisaType: row.visaType,
                        planName: quoteData?.planName,
                        Relation: row.Relation,
                        NomineeRelation: row.trv_nomineerelation,
                        IsUnderMedication:
                            diseases?.length > 0 ? diseases[0].isFirstMemberChecked : false,
                        productCode: quoteData?.productCode,
                        coverageTypeId: String(quoteData?.coverageTypeId),
                        IsVisitingUSACanada: QuoteData?.isVisitingUSACanada,
                        CityID: cityId,
                        StateName: cityState?.state_Name || "",
                        CityName: cityState?.cityName || "",
                        DistrictID: districtId,
                        StateID: cityState?.stateId || "",
                        ExistingIllness:
                            diseases?.length > 0 && diseases[0].isFirstMemberChecked
                                ? diseases[0].DiseaseName
                                : null,
                        SufferingSince:
                            diseases?.length > 0 && diseases[0].preExistingillness
                                ? diseases[0].sufferingDate
                                : null,
                        MedicationName:
                            diseases?.length > 0 && diseases[0].preExistingillness
                                ? diseases[0].description
                                : null,
                        isMedicine:
                            diseases?.length > 0 && diseases[0].preExistingillness
                                ? diseases[0].isMedicine
                                : false,
                        CourseDuration: row.courseDuration || null,
                        NoOfSems: row.semesterNumber || null,
                        UniversityName: row.UniversityName || null,
                        isIndianCitizen:
                            diseases?.length > 0 ? diseases[0]?.isIndianCitizen : null,
                        IsResidingInIndia:
                            diseases?.length > 0 ? diseases[0]?.IsResidingInIndia : null,
                        isOverseasCitizen:
                            diseases?.length > 0 ? diseases[0]?.isOverseasCitizen : null,
                        countryOfPermanentResidence:
                            diseases?.length > 0
                                ? diseases[0]?.countryOfPermanentResidence
                                : "",
                        ociNumber: diseases?.length > 0 ? diseases[0]?.ociNumber : "",
                        passportIssuingCountry:
                            diseases?.length > 0 ? diseases[0]?.passportIssuingCountry : "",
                        isImmigrationVisa:
                            diseases?.length > 0 ? diseases[0]?.isImmigrationVisa : null,
                    };
                }),
            };
            window.sessionStorage.setItem("ProposalReq", JSON.stringify(body));
            const res = await axios.post(`${baseUrl}/services/call`, {
                URL: "/api/Proposal/GetProposal",
                PostString: JSON.stringify(body),
            });
            if (res.data.statusCode === 200) {
                setLoader(false);
                if (res.data.response.success) {
                    navigate("/PaymentSummery", {
                        state: {
                            KYCDetails,
                            ProposalData,
                            ProposalReq: JSON.parse(
                                window.sessionStorage.getItem("ProposalReq"),
                            ),
                            quoteData,
                            travellers,
                            proposalResponse: res.data,
                        },
                    });
                } else {
                    alert(res.data.response.errorMsg);
                }
            } else {
                setLoader(false);
            }
        } catch (e) {
            setLoader(false);
            console.error(e);
        }
    };
    const getProposerMobile = () =>
        String(
            travellers?.[0]?.mobileNo ||
            travellerDetails?.mobileNo ||
            ProposalData?.MobileNo ||
            "",
        ).trim();

    const OncontactDetailSubmit = (data) => {
        setLoader(true);
        try {
            settravellerAddress(data);
            const currentTraveller =
                travellers?.[0] || locationData?.Travellers?.[0] || {};
            setKYCDetails({
                EnquiryNo: QuoteData.enquiryNo,
                TransectionID: "",
                DOB: formatDateForApi(currentTraveller?.dob),
                Name: currentTraveller?.fullName,
                Gender: currentTraveller?.gender,
                Mobile: data?.MobileNo || ProposalData?.MobileNo,
                Email: data?.Email || currentTraveller?.email,
                CompanyID: QuoteData.insurerID,
                PinCode: data?.Pincode,
                IsCorporate: false,
                ProductType: 5,
                DocType: KYCDetailsState.DocType ?? "PAN",
                DocNumber: KYCDetailsState.DocNumber ?? currentTraveller?.ProposerPAN,
                Type: 0,
                PolicyType: "0",
                TypeOfPolicy: 1,
                nomineeDetails: { Name: "", RelationShip: "" },
                AddressDetails: {
                    PinCode: data?.Pincode,
                    StateName: "",
                    CityName: "",
                    AddressLine1: data?.Address1,
                    AddressLine2: data?.Address2,
                    AddressLine3: "",
                    PerAddressLine1: "",
                    PerAddressLine2: "",
                    PerAddressLine3: "",
                    PerCityName: "",
                    PerPinCode: "",
                    PerStateName: "",
                    IsChangeAddress: "",
                },
            });
            setShowKyc(true);
        } catch (error) {
            console.error(error);
            toast.error("Failed to proceed");
        } finally {
            setLoader(false);
        }
    };

    const CallKYCFunction = (data) => {
        setKYCDetails(data);
        paymentsummery();
        setShowKyc(false);
    };

    const stepStatus = (key) => {
        const active = Number(activeKey);
        const k = Number(key);
        if (k === active) return "active";
        if (k < active) return "done";
        return "";
    };

    if (!QuoteData) return <VLoader />;

    /* ── Sidebar data helpers ── */
    const destinations =
        locationData?.destination
            ?.map?.((d) =>
                typeof d === "string" ? d : d?.CountryName || d?.label || "",
            )
            .filter(Boolean) || [];

    const travellerChips =
        locationData?.Travellers?.map?.((t, i) => ({
            label: i === 0 ? `Self · ${t.age || ""}Y` : `Member · ${t.age || ""}Y`,
        })) || [];

    return (
        <div className="pg-page">
            {isLoader && <VLoader />}

            {/* ── Plan Banner ── */}
            <div className="pg-banner">
                <div className="container">
                    <div className="pg-banner-inner">
                        <div className="pg-banner-left">
                            <button
                                type="button"
                                className="pg-back-link"
                                onClick={handleQuotationBackClick}
                            >
                                <i className="fa fa-arrow-left" /> Back to Quotations
                            </button>
                            <div>
                                <div className="pg-banner-plan-name">Payment Gateway</div>
                                <div className="pg-banner-plan-sub">
                                    {destinations.join(", ") || "International Travel"}
                                    {destinations.length > 0 && " · "}
                                    {locationData?.numberofDays
                                        ? `${locationData.numberofDays} days`
                                        : "Review and continue"}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Stepper ── */}
            <Modal
                show={showQuotationBackModal}
                onHide={handleQuotationBackCancel}
                centered
                backdrop="static"
                keyboard={false}
                className="pg-confirm-modal"
            >
                <Modal.Body className="pg-confirm-body">
                    <div className="pg-confirm-icon">
                        <svg viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 8v4"
                                stroke="currentColor"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                            />
                            <path
                                d="M12 16h.01"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M10.29 3.86L1.82 18a2 2 0 0 0 1.72 3h16.92a2 2 0 0 0 1.72-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
                                stroke="currentColor"
                                strokeWidth="1.6"
                            />
                        </svg>
                    </div>
                    <h4 className="pg-confirm-title">Go back to Quotation?</h4>
                    <p className="pg-confirm-text">
                        This will reset all your proposer details. You will need to fill
                        them again when you return.
                    </p>
                    <div className="pg-confirm-actions">
                        <button
                            type="button"
                            className="pg-confirm-btn pg-confirm-btn--ghost"
                            onClick={handleQuotationBackCancel}
                        >
                            Stay here
                        </button>
                        <button
                            type="button"
                            className="pg-confirm-btn pg-confirm-btn--primary"
                            onClick={handleQuotationBackConfirm}
                        >
                            Yes, go back
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <div className="pg-stepper-wrap">
                <div className="container">
                    <div className="pg-stepper-row">
                        <button
                            type="button"
                            className="pg-back-link"
                            onClick={handleQuotationBackClick}
                        >
                            <svg
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M10 3L5 8l5 5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            Back to Quotations
                        </button>

                        <div className="pg-stepper">
                            {visibleSteps.map((step, i) => (
                                <React.Fragment key={step.key}>
                                    <div className={`pg-step ${stepStatus(step.sourceKey)}`}>
                                        <button
                                            className="pg-step-btn"
                                            type="button"
                                            disabled={!canNavigateToStep(step.sourceKey)}
                                            onClick={() => {
                                                if (canNavigateToStep(step.sourceKey)) {
                                                    setActiveKey(step.sourceKey);
                                                }
                                            }}
                                            aria-disabled={!canNavigateToStep(step.sourceKey)}
                                        >
                                            <div className="pg-step-num">
                                                {stepStatus(step.sourceKey) === "done" ? (
                                                    <svg
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2.5"
                                                        viewBox="0 0 16 16"
                                                        width="12"
                                                        height="12"
                                                    >
                                                        <path
                                                            d="M3 8l3.5 3.5L13 4.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                ) : (
                                                    step.key
                                                )}
                                            </div>
                                            <span className="pg-step-label">{step.label}</span>
                                        </button>
                                    </div>
                                    {i < visibleSteps.length - 1 && (
                                        <div
                                            className={`pg-step-connector${Number(activeKey) > Number(step.sourceKey)
                                                    ? " done"
                                                    : ""
                                                }`}
                                        />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Main layout ── */}
            <div className="container">
                <div className="pg-layout">
                    {/* LEFT: form area */}
                    <div>
                        {/* Step 1 */}
                        {activeKey === "1" && (
                            <div className="pg-form-card">
                                <div className="pg-form-card-header">
                                    <div className="pg-form-card-icon">
                                        <svg
                                            fill="none"
                                            stroke="var(--brand-primary-deep)"
                                            strokeWidth="1.8"
                                            viewBox="0 0 20 20"
                                        >
                                            <circle cx="10" cy="6" r="3.5" />
                                            <path
                                                d="M3 18c0-3.3 3.1-6 7-6s7 2.7 7 6"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </div>
                                    <div>
                                        <div className="pg-form-card-title">Proposer Details</div>
                                        <div className="pg-form-card-sub">
                                            The proposer is the policyholder who pays the premium ff
                                        </div>
                                    </div>
                                </div>
                                <div className="pg-form-card-body">
                                    <Travellerdetailform
                                        HandleFormValidation={setIsFormValid}
                                        ProposalData={ProposalData}
                                        quoteData={quoteData}
                                        travellersList={travellers}
                                        setTravellers={setTravellers}
                                    />
                                </div>
                                <div className="pg-continue-row">
                                    <button
                                        type="button"
                                        className="pg-continue-btn"
                                        onClick={handleProposerContinue}
                                        disabled={isProposerSaving || !isFormValid}
                                    >
                                        {isProposerSaving ? (
                                            <>
                                                Saving...
                                                <span className="pg-btn-spinner" />
                                            </>
                                        ) : (
                                            <>
                                                Continue to Additional Details
                                                <svg
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path
                                                        d="M6 3l5 5-5 5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Step 2 */}
                        {activeKey === "2" && (
                            <div className="pg-form-card">
                                <div className="pg-form-card-header">
                                    <div className="pg-form-card-icon">
                                        <svg
                                            fill="none"
                                            stroke="var(--brand-primary-deep)"
                                            strokeWidth="1.8"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                d="M10 2a5 5 0 100 10A5 5 0 0010 2zM4 18s-1-4 6-4 6 4 6 4"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </div>
                                    <div>
                                        <div className="pg-form-card-title">Member Details</div>
                                        <div className="pg-form-card-sub">
                                            {skipMemberStep
                                                ? "Single traveller details captured from proposer form"
                                                : "Traveller information for the insured member"}
                                        </div>
                                        {/* {skipMemberStep && (
                      <div className="pg-member-preview-strip">
                        {[
                          ["Name", currentTravellerPreview?.fullName || "—"],
                          ["Gender", currentTravellerPreview?.gender || "—"],
                          [
                            "DOB",
                            currentTravellerPreview?.dob || "—",
                          ],
                          [
                            "Nominee",
                            currentTravellerPreview?.nomineeName || "—",
                          ],
                        ].map(([label, value]) => (
                          <div className="pg-member-preview-chip" key={label}>
                            <span className="pg-member-preview-label">{label}</span>
                            <span className="pg-member-preview-value">{value}</span>
                          </div>
                        ))}
                      </div>
                    )} */}
                                    </div>
                                </div>
                                <div className="pg-form-card-body" style={{ minHeight: 120 }}>
                                    {skipMemberStep ? (
                                        <div className="pg-member-summary">
                                            {[
                                                [
                                                    "Salutation",
                                                    getCurrentTraveller()?.salutation || "—",
                                                ],
                                                //["Full Name", getCurrentTraveller()?.fullName || "—"],
                                                ["Full Name", maskName(getCurrentTraveller()?.fullName) || "—"],
                                                ["Gender", getCurrentTraveller()?.gender || "—"],
                                                ["DOB", formatDobDisplay(getCurrentTraveller()?.dob)],
                                                /*[
                                                  "PAN",
                                                  toUpperDisplay(getCurrentTraveller()?.ProposerPAN) ||
                                                    "—",
                                                ],*/
                                                ["PAN", maskPan(getCurrentTraveller()?.ProposerPAN) || "—"],
                                                /*[
                                                  "Passport No",
                                                  toUpperDisplay(
                                                    getCurrentTraveller()?.passportNumber,
                                                  ) || "—",
                                                ],*/
                                                ["Passport No", maskPassport(getCurrentTraveller()?.passportNumber) || "—"],
                                                [
                                                    "Occupation",
                                                    getOccupationName(
                                                        getCurrentTraveller()?.occupation,
                                                    ) || "—",
                                                ],
                                                //["Nominee", getCurrentTraveller()?.nomineeName || "—"],
                                                ["Nominee", maskName(getCurrentTraveller()?.nomineeName) || "—"],
                                                [
                                                    "Nominee Relation",
                                                    getNomineeRelationName(
                                                        getCurrentTraveller()?.trv_nomineerelation,
                                                    ) || "—",
                                                ],
                                            ].map(([label, value]) => (
                                                <div className="pg-member-summary-row" key={label}>
                                                    <div className="pg-member-summary-label">{label}</div>
                                                    <div className="pg-member-summary-value">{value}</div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <MemberDetailForm
                                            onValidityChange={setIsMemberFormValid}
                                            onChange={setMemberDetailsData}
                                        />
                                    )}
                                </div>
                                <div className="pg-continue-row">
                                    <button
                                        type="button"
                                        className="pg-continue-btn"
                                        onClick={() => handleMemberContinue(false)}
                                        disabled={
                                            isMemberSaving ||
                                            (skipMemberStep ? false : !isMemberFormValid)
                                        }
                                    >
                                        {skipMemberStep ? (
                                            isMemberSaving ? (
                                                <>
                                                    Saving member details...
                                                    <span className="pg-btn-spinner" />
                                                </>
                                            ) : (
                                                <>
                                                    Continue to Additional Details
                                                    <svg
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2.5"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            d="M6 3l5 5-5 5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </>
                                            )
                                        ) : isMemberSaving ? (
                                            <>
                                                Saving member details...
                                                <span className="pg-btn-spinner" />
                                            </>
                                        ) : (
                                            <>
                                                Continue to Medical Questions
                                                <svg
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path
                                                        d="M6 3l5 5-5 5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Step 3 */}
                        {activeKey === "3" && (
                            <div className="pg-form-card">
                                <div className="pg-form-card-header">
                                    <div className="pg-form-card-icon">
                                        <svg
                                            fill="none"
                                            stroke="var(--brand-primary-deep)"
                                            strokeWidth="1.8"
                                            viewBox="0 0 20 20"
                                        >
                                            <path d="M10 2C7.2 2 5 4.2 5 7c0 3.9 5 11 5 11s5-7.1 5-11c0-2.8-2.2-5-5-5zm0 6.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <div className="pg-form-card-title">Medical Questions</div>
                                        <div className="pg-form-card-sub">
                                            Please confirm the health and travel declarations
                                        </div>
                                    </div>
                                </div>
                                <div className="pg-form-card-body" style={{ minHeight: 120 }}>
                                    <MemberQuestionsForm
                                        onValidityChange={setIsQuestionFormValid}
                                        onChange={setMemberQuestionsData}
                                    />
                                </div>
                                <div className="pg-continue-row">
                                    <button
                                        type="button"
                                        className="pg-continue-btn"
                                        onClick={handleQuestionsContinue}
                                        disabled={!isQuestionFormValid || isAdditionalSaving}
                                    >
                                        {isAdditionalSaving ? (
                                            <>
                                                Saving...
                                                <span className="pg-btn-spinner" />
                                            </>
                                        ) : (
                                            <>
                                                Continue to Address
                                                <svg
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2.5"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path
                                                        d="M6 3l5 5-5 5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Step 4 */}
                        {activeKey === "4" && (
                            <div className="pg-form-card">
                                <div className="pg-form-card-header">
                                    <div className="pg-form-card-icon">
                                        <svg
                                            fill="none"
                                            stroke="var(--brand-primary-deep)"
                                            strokeWidth="1.8"
                                            viewBox="0 0 20 20"
                                        >
                                            <path d="M10 2C7.2 2 5 4.2 5 7c0 3.9 5 11 5 11s5-7.1 5-11c0-2.8-2.2-5-5-5zm0 6.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <div className="pg-form-card-title">
                                            Communication Address
                                        </div>
                                        <div className="pg-form-card-sub">
                                            Correspondence and contact information
                                        </div>
                                    </div>
                                </div>
                                <div className="pg-form-card-body" style={{ minHeight: 120 }}>
                                    <Contactdetailform
                                        QuoteInsurerId={QuoteData?.insurerID}
                                        //ProposalMobileNo={ProposalData?.MobileNo}
                                        ProposalMobileNo={getProposerMobile()}
                                        QuoteData={QuoteData}
                                        setPincodeState={setPincodeState}
                                        OncontactDetailSubmit={OncontactDetailSubmit}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {/* RIGHT: policy summary sidebar */}
                    <div className="pg-sidebar">
                        <div className="pg-summary-card">
                            <div className="pg-summary-header">
                                <span className="pg-summary-header-title">Policy Summary</span>
                            </div>
                            <div className="pg-summary-body">
                                <div className="pg-summary-row">
                                    {/* <div className="pg-summary-row-label">Plan</div> */}
                                    <div
                                        style={{ display: "flex", alignItems: "center", gap: 10 }}
                                    >
                                        <div
                                            className="pg-banner-logo"
                                            style={{ width: 44, height: 44 }}
                                        >
                                            {QuoteData?.InsurerLogo ? (
                                                <img
                                                    src={QuoteData.InsurerLogo}
                                                    alt={QuoteData.planName}
                                                />
                                            ) : (
                                                <svg
                                                    fill="none"
                                                    stroke="var(--brand-primary-deep)"
                                                    strokeWidth="1.5"
                                                    viewBox="0 0 24 24"
                                                    width="24"
                                                    height="24"
                                                >
                                                    <path d="M12 3L4 7v5c0 5 4.5 9.5 8 11 3.5-1.5 8-6 8-11V7L12 3z" />
                                                </svg>
                                            )}
                                        </div>
                                        <div>
                                            <div className="pg-summary-row-val">
                                                {QuoteData.planName || "Travel Insurance Plan"}
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: 11.5,
                                                    color: "var(--pg-text-3)",
                                                    marginTop: 2,
                                                }}
                                            >
                                                {QuoteData?.ProductName ||
                                                    QuoteData?.productName ||
                                                    "Policy snapshot"}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="pg-summary-row">
                                    <div className="pg-summary-row-label">Enquiry No</div>
                                    <div className="pg-summary-row-val">
                                        {QuoteData.enquiryNo || enquiryState?.EnquiryNo || "—"}
                                    </div>
                                </div>

                                <div className="pg-summary-row">
                                    <div className="pg-summary-row-label">Final Premium</div>
                                    <div className="pg-summary-row-val large">
                                        ₹
                                        {formatINR(
                                            QuoteData?.NetPremium
                                                ? QuoteData.NetPremium
                                                : QuoteData?.finalPremium || 0,
                                        )}
                                    </div>
                                </div>

                                <div className="pg-summary-divider" />

                                <div className="pg-summary-row">
                                    <div className="pg-summary-row-label">Policy Term</div>
                                    <div className="pg-summary-row-val">
                                        {locationData?.numberofDays
                                            ? `${locationData.numberofDays} Days`
                                            : "1 Year"}
                                    </div>
                                </div>

                                <div className="pg-summary-row">
                                    <div className="pg-summary-row-label">Coverage Period</div>
                                    <div className="pg-summary-date-row">
                                        <div className="pg-summary-date-block">
                                            <div className="pg-summary-date-label">From</div>
                                            <div className="pg-summary-date-val">
                                                {locationData?.startDate
                                                    ? new Date(locationData.startDate).toLocaleDateString(
                                                        "en-IN",
                                                        {
                                                            day: "numeric",
                                                            month: "short",
                                                            year: "numeric",
                                                        },
                                                    )
                                                    : "—"}
                                            </div>
                                        </div>
                                        {/* <span className="pg-summary-arrow">→</span> */}
                                        <div className="pg-summary-date-block">
                                            <div className="pg-summary-date-label">To</div>
                                            <div className="pg-summary-date-val">
                                                {locationData?.endDate
                                                    ? new Date(locationData.endDate).toLocaleDateString(
                                                        "en-IN",
                                                        {
                                                            day: "numeric",
                                                            month: "short",
                                                            year: "numeric",
                                                        },
                                                    )
                                                    : "—"}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {travellerChips.length > 0 && (
                                    <>
                                        <div className="pg-summary-divider" />
                                        <div className="pg-summary-row">
                                            <div className="pg-summary-row-label">Members</div>
                                            <div className="pg-member-chips">
                                                {travellerChips.map((c, i) => (
                                                    <span key={i} className="pg-member-chip">
                                                        <svg
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            viewBox="0 0 16 16"
                                                            width="11"
                                                            height="11"
                                                        >
                                                            <circle cx="8" cy="5" r="2.5" />
                                                            <path
                                                                d="M3 14c0-2.8 2.2-5 5-5s5 2.2 5 5"
                                                                strokeLinecap="round"
                                                            />
                                                        </svg>
                                                        {c.label}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                )}

                                {destinations.length > 0 && (
                                    <>
                                        <div className="pg-summary-divider" />
                                        <div className="pg-summary-row">
                                            <div className="pg-summary-row-label">Destination</div>
                                            <div
                                                className="pg-summary-row-val"
                                                style={{ fontSize: 12 }}
                                            >
                                                {destinations.join(", ")}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {ckycModalState.open &&
                (ckycModalState.mode === "redirect" ? (
                    <VeryficationCKYC
                        URL={ckycModalState.redirectUrl}
                        onKYCSubmit={handleRedirectKycSubmit}
                        closeKYC={closeCkycModal}
                    />
                ) : (
                    <DocTypeUpload
                        CKYCData={kycData}
                        Companyid={QuoteData?.insurerID}
                        EnquiryNo={QuoteData?.enquiryNo}
                        setKYCDetails={setKYCDetails}
                        onUploadSuccess={handleUploadSuccess}
                        onKycSubmit={closeCkycModal}
                    />
                ))}

            {ShowKyc && (
                <CKYCHome
                    CKYCData={kycData}
                    KYCDetails={KYCDetails}
                    travellersPanNo={travellers[0]?.ProposerPAN}
                    QuoteData={QuoteData}
                    travellerAddress={travellerAddress}
                    travellers={travellers}
                    setShowKyc={setShowKyc}
                    IsProposalKYC={true}
                    onKycSubmit={CallKYCFunction}
                    closeKYC={() => setShowKyc(false)}
                />
            )}
        </div>
    );
};

export default Paymentgateawaye;
